import { StyleSheet } from 'react-native';

const ResourceLightPurpleButtonImage = ({ style }) => {
  const oneX = require('./resource-light-purple-button.jpg');
  const twoX = require('./resource-light-purple-button@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={StyleSheet.flatten(style)}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { ResourceLightPurpleButtonImage };
